module.exports = __webpack_public_path__ + "img/Eterna-logo_1a.f442a0ee.jpg";